<template>
  <div>
    <b-form-checkbox
      :id="`device-${device.id}`"
      :name="`device-${device.id}`"
      :disabled="localLoading"
      :checked="device.status === 'ARMED' || device.status === 'BURGLARY'"
      switch
      @change="handleToggle"
      v-if="isVisible"
    >
      {{ titleAction(device.status) }}
    </b-form-checkbox>
  </div>
</template>

<script>
import {computed, ref} from "@vue/composition-api";
import {useDeviceMessages} from "./composables/useDeviceMessages";
import axios from "@axios";
import {useUtils as useAclUtils} from "@core/libs/acl";

export default {
  name: "DmpArea",
  props: {
    device: Object,
    trans: Object,
    loadingToast: Object,
    updateStatus: Function,
  },
  setup(props) {
    const {confirmArmAlert, confirmActionAlert, successAlertAction, errorAlertAction, showToast} = useDeviceMessages(props.trans);
    const localLoading = ref(false);
    const { can } = useAclUtils();

    const handleToggle = async () => {

      let result;
      if (props.device.status.includes('DISARMED')) {
        result = await confirmArmAlert(props.device, 'Arm');
      } else {
        result = await confirmActionAlert(props.device, 'Disarm');
      }

      if (!result.isConfirmed) {
        document.getElementById(`device-${props.device.id}`).checked = (props.device.status === 'ARMED' || props.device.status === 'BURGLARY');
        return;
      }

      localLoading.value = true;
      showToast(props.device.status, props.device, props.loadingToast);

      try {
        const action = (props.device.status === "ARMED" || props.device.status === "BURGLARY") ? 1 : 0;
        let urlAction = "";
        if (props.device.actions.length > 1) {
          urlAction = props.device.actions[action]?.data?.url;
        } else {
          urlAction = props.device.actions[0]?.data?.url;
        }

        await axios.get(urlAction+'&mode='+result.value);

        // Deprecated
        //props.updateStatus();

        successAlertAction(props.device);
      } catch (error) {
        document.getElementById(`device-${props.device.id}`).checked = (props.device.status === 'ARMED' || props.device.status === 'BURGLARY');
        console.error(`error in request for device ${props.device.text}:`, JSON.stringify(error));
        errorAlertAction(props.device.status, error.response?.data?.message);
      } finally {
        localLoading.value = false;
        if (props.loadingToast) props.loadingToast.close();
      }
    };

    const titleAction = (status) => ((status === "ARMED"|| status === "BURGLARY") ? props.trans["dmp.deactivate"] : props.trans["dmp.activate"]);

    const isVisible = computed(() => {
      if (can("disarm_area", "DmpPanel") && can("arm_area", "DmpPanel")) return true;
      if (props.device.status === "ARMED" || props.device.status === "BURGLARY") {
        return can("disarm_area", "DmpPanel");
      } else if (props.device.status === "DISARMED") {
        return can("arm_area", "DmpPanel");
      }
    });

    return {handleToggle, titleAction, localLoading, isVisible};
  },
};
</script>
